import React, { useContext } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import FormInput from '../../../../FormCollection/FormInput';
import { UseFormReturn } from 'react-hook-form';
import { IFormTypes } from '../../Types';
import { FormContainer, FormDescription } from './style';
import PrimaryBtn from '../../../../FormCollection/PrimaryBtn';
import { CheckoutContext, CheckoutContextProps } from '../../../../../context/CheckoutContext';
import { DFC_SCHOOL_EXPERIENCE_COMPANY_ID } from '../../../../../Utils/constants';
import { SCHOOL_REGISTRATION_NOTICE } from '../../../../../Utils/schoolExperienceCopy';

interface ISignupFormProps {
  form: UseFormReturn<IFormTypes, any>;
  onSubmit: (data: IFormTypes) => void;
  isLoading: boolean;
}

const SignupForm: React.FC<ISignupFormProps> = ({ form, onSubmit, isLoading }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = form;

  const theme = useTheme();
  const { company } = useContext(CheckoutContext) as CheckoutContextProps;
  const isDfcSchoolExperience = company?.id === DFC_SCHOOL_EXPERIENCE_COMPANY_ID;
  return (
    <FormContainer
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      {isDfcSchoolExperience && (
        <FormDescription theme={theme}>{SCHOOL_REGISTRATION_NOTICE}</FormDescription>
      )}

      <FormInput
        error={errors.email}
        placeholder={'Email Address*'}
        register={register('email')}
        id="email"
        type="email"
        dataTestId="email-input"
      />

      <PrimaryBtn
        isLoading={isLoading}
        type="submit"
        text="Continue"
        dataTestId="submit-button"
        disabled={isLoading}
      />
    </FormContainer>
  );
};

export default SignupForm;
